(() => {
  const remembered = { exp: "" };

  const forceFromQuery = () => {
    const value = Number(new URLSearchParams(window.location.search).get("nudge"));
    return value >= 1 && value <= 4 ? value : 0;
  };

  const isEligible = (node, hasForced) => {
    if (hasForced) return node.classList.contains("is-forced");
    return node.classList.contains("is-ig-visible");
  };

  class PdpDesignNudge extends HTMLElement {
    connectedCallback() {
      this.restore();
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this, { attributes: true, subtree: true, attributeFilter: ["class"] });
      this.sync();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo()?.classList.remove("is-nudge-without-lower");
    }

    restore() {
      const forced = forceFromQuery();
      if (forced) {
        this.querySelectorAll(".pdp-design-nudge").forEach((node) => {
          node.classList.toggle("is-forced", node.dataset.exp === String(forced));
        });
        return;
      }
      const current = this.querySelector(".pdp-design-nudge.is-ig-visible");
      if (current?.dataset.exp) {
        remembered.exp = current.dataset.exp;
        return;
      }
      if (!remembered.exp && window.__pdpNudgeExp) remembered.exp = String(window.__pdpNudgeExp);
      if (!remembered.exp) return;
      this.querySelector(`.pdp-design-nudge[data-exp="${remembered.exp}"]`)?.classList.add("is-ig-visible");
    }

    productInfo() {
      return this.closest(".product-info");
    }

    sync() {
      const nodes = [...this.querySelectorAll(".pdp-design-nudge")];
      const hasForced = nodes.some((node) => node.classList.contains("is-forced"));
      let active = null;
      nodes.forEach((node) => {
        const show = !active && isEligible(node, hasForced);
        if (show) active = node;
        if (node.hidden === show) node.hidden = !show;
      });
      if (active?.classList.contains("is-ig-visible")) remembered.exp = active.dataset.exp;
      this.productInfo()?.classList.toggle("is-nudge-without-lower", Boolean(active?.hasAttribute("data-hide-lower")));
    }
  }

  if (!window.customElements.get("pdp-design-nudge")) {
    window.customElements.define("pdp-design-nudge", PdpDesignNudge);
  }
})();
